// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".code-editor{margin-bottom:8px;width:100%;border:2px solid #000}.code-editor.active{border:2px solid var(--color-primary)}.code-editor pre{margin-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
